import { Grid, TextField, Typography } from "@mui/material";
import { isFulfilled } from "@reduxjs/toolkit";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../app/hooks";
import BasicDialog from "../../../common/components/functional/dialogs/BasicDialog";
import OverlaySpinner from "../../../common/components/functional/overlaySpinner/OverlaySpinner";
import useIsLoading from "../../../hooks/useIsLoading";
import useMessage from "../../../hooks/useMessage";
import { convertToCreditInvoice } from "../invoiceDetailedSlice";

type Props = {
  invoiceId: string;
  open: boolean;
  toggleOpen: () => void;
};

const ConvertToCreditInvoiceDialog = ({
  invoiceId,
  open,
  toggleOpen,
}: Props) => {
  const [originalInvoiceId, setOriginalInvoiceId] = useState("");

  const { t } = useTranslation("invoices");

  const { sendMessage } = useMessage();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isLoading = useIsLoading(["invoicesDetailed"]);

  const confirmDisabled = !originalInvoiceId || isLoading;

  const save = () => {
    dispatch(convertToCreditInvoice({ invoiceId, originalInvoiceId })).then(
      (action) => {
        if (isFulfilled(action)) {
          sendMessage(t("changedToCreditInvoice"), "success");
          navigate("/home/invoices");
          toggleOpen();
        }
      },
    );
  };

  return (
    <BasicDialog
      open={open}
      onCancel={toggleOpen}
      onConfirm={save}
      title={t("changeToCreditInvoice")}
      PaperProps={{ sx: { minWidth: "640px" } }}
      confirmDisabled={confirmDisabled}
      noBorder
      content={
        <Grid container spacing={2} mb={2}>
          <OverlaySpinner
            sx={{ position: "absolute", width: "100%", height: "100%" }}
            isLoading={isLoading}
          />
          <Grid xs={4} item alignSelf="center" justifyItems="end">
            <Typography color="text.secondary" textAlign="end">
              {t("originalInvoiceNumberLong")}
            </Typography>
          </Grid>
          <Grid xs={8} item>
            <TextField
              fullWidth
              size="small"
              value={originalInvoiceId}
              onChange={(e) => setOriginalInvoiceId(e.target.value.trim())}
            />
          </Grid>
        </Grid>
      }
    />
  );
};

export default ConvertToCreditInvoiceDialog;
